import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const Wrapper = styled.div`
  display: ${(props) => props.display};
  flex-direction: column-reverse;
  margin: 0 auto;
  padding: 0 15px;
  width: 100%;

  @media ${breakpoints.small} {
    max-width: 540px;
  }

  @media ${breakpoints.large} {
    max-width: 700px;
  }

  @media ${breakpoints.extraLarge} {
    flex-direction: row;
    max-width: 1200px;
    margin: auto auto;
    padding: 0;
  }
`;
